import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from '@material-ui/core';

import { Quote } from '../../types/quote.type';

type QuoteAction = 'accept' | 'refuse' | 'cancel';

type Props = {
  open: boolean;
  action: QuoteAction;
  quote: Quote;
  isSubmitting?: boolean;
  onConfirm: () => Promise<void> | void;
  onClose: () => void;
};

type ActionCopy = {
  title: string;
  body: (quoteNumber: string) => string;
  confirmLabel: string;
  confirmColor: 'primary' | 'secondary';
};

const ACTION_COPY: Record<QuoteAction, ActionCopy> = {
  accept: {
    title: 'Accepter le devis',
    body: (number) => `Marquer le devis ${number} comme accepté ? Une commande sera créée.`,
    confirmLabel: 'Accepter',
    confirmColor: 'primary',
  },
  refuse: {
    title: 'Refuser le devis',
    body: (number) => `Marquer le devis ${number} comme refusé ?`,
    confirmLabel: 'Refuser',
    confirmColor: 'secondary',
  },
  cancel: {
    title: 'Annuler le devis',
    body: (number) => `Annuler le devis ${number} ? Cette action est irréversible.`,
    confirmLabel: 'Annuler le devis',
    confirmColor: 'secondary',
  },
};

const useStyles = makeStyles({
  root: {
    '& > .MuiDialog-container': {
      '& > .MuiPaper-root': {
        minWidth: '400px',
      },
    },
  },
});

export function ConfirmQuoteActionDialog({ open, action, quote, isSubmitting = false, onConfirm, onClose }: Props) {
  const classes = useStyles();
  const copy = ACTION_COPY[action];

  const handleClose = () => {
    if (isSubmitting) return;
    onClose();
  };

  const handleConfirm = async () => {
    await onConfirm();
  };

  return (
    <Dialog open={open} onClose={handleClose} className={classes.root}>
      <DialogTitle>{copy.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{copy.body(quote.number)}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="default" disabled={isSubmitting}>
          Annuler
        </Button>
        <Button
          onClick={handleConfirm}
          color={copy.confirmColor}
          variant="contained"
          disabled={isSubmitting}
          startIcon={isSubmitting ? <CircularProgress size={16} /> : null}
        >
          {copy.confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
